import { FlagIcon } from "../utils/countries.jsx";
import CustomSelect from "./CustomSelect.jsx";

/**
 * Thin wrapper around CustomSelect that prepends a FlagIcon to each country option.
 */
const CountrySelect = ({ value, onChange, options, placeholder = "Global", variant = "pill" }) => (
  <CustomSelect
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    placeholderIcon={<span>🌍</span>}
    variant={variant}
    options={options.map((opt) => ({
      ...opt,
      icon: <FlagIcon code={opt.value} />,
    }))}
  />
);

export default CountrySelect;
